import { Component, OnInit, ViewChild } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { FeedbackService } from '../../service/feedback.service';
import { FeedbackDialogComponent } from '../feedback-dialog/feedback-dialog.component';
import { ToastrService } from 'ngx-toastr';
import { MatTableDataSource } from '@angular/material/table';
import { MatPaginator } from '@angular/material/paginator';
import { LiveAnnouncer } from '@angular/cdk/a11y';
import { MatSort, Sort } from '@angular/material/sort';
import { InteractionService } from '../../service/interaction/interaction.service';



@Component({
    selector: 'app-feedback-trainee',
    templateUrl: './feedback-trainee.component.html',
    styleUrl: './feedback-trainee.component.scss',
    standalone: false
})
export class FeedbackTraineeComponent implements OnInit {
  applicationFeedbacks: any[] = [];

  displayedColumnsApp = ['app_feedback_id', 'created_date', 'app_feedback_topic', 'feedback_value', 'app_feedback_description'];
  dataSource = new MatTableDataSource<any>();
  @ViewChild(MatPaginator) paginator: MatPaginator;

  constructor(private feedbackService: FeedbackService, private dialog: MatDialog, 
    private toastr: ToastrService, private _liveAnnouncer: LiveAnnouncer, private readonly intService: InteractionService,) { }

  @ViewChild(MatSort) sort: MatSort;


  ngOnInit(): void {
    this.loadApplicationFeedback();
    this.intService.isProductSelected.subscribe(res =>{
      if(res){
        this.dataSource =new MatTableDataSource([]);
        this.loadApplicationFeedback();
      }
    })
  }

  ngAfterViewInit() {
    this.dataSource.sort = this.sort;
  }

  loadApplicationFeedback(): void {
    this.feedbackService.getApplicationFeedbackByUserId().subscribe(data => {
    this.dataSource=new MatTableDataSource(data);
    this.dataSource.sort= this.sort;
    this.dataSource.paginator= this.paginator;
    // this.applicationFeedbacks = data;

    });
  }


  sortData(sort: Sort) {
    if (sort.direction) {
      this._liveAnnouncer.announce(`Sorted ${sort.direction}ending`);
    } else {
      this._liveAnnouncer.announce('Sorting cleared');
    }
  }

  openFeedbackDialog(): void {
    const dialogRef = this.dialog.open(FeedbackDialogComponent);

    dialogRef.afterClosed().subscribe(result => {
      if (result) {
        this.toastr.success('Feedback Saved Successfully', '', { positionClass: 'toast-top-right' });        // this.Router.navigate(['/app-home'], { skipLocationChange: true });

        this.loadApplicationFeedback(); // Refresh the feedback list after submitting
      }
    });
  }
  convertUtcToLocal(utcDateString: string): Date | null {
    if (!utcDateString) return null;
    const utcDate = utcDateString.split('.')[0] + 'Z';
    return new Date(utcDate);
  }

  processData(data: any[]): any[] {
    return data.map(item => ({
      ...item,
      created_date: this.convertUtcToLocal(item.created_date) 
    }));
  }

}
